/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelettivaCountPartecipanteDto } from '../../models/selettiva-count-partecipante-dto';

export interface ApiSelettivaSelettivaCountPartecipantiGet$Params {
    /**
     * id della selettiva per cui caricare i partecipanti
     */
    selettivaId: number;
}

export function apiSelettivaSelettivaCountPartecipantiGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiSelettivaSelettivaCountPartecipantiGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<SelettivaCountPartecipanteDto>> {
    const rb = new RequestBuilder(rootUrl, apiSelettivaSelettivaCountPartecipantiGet.PATH, 'get');
    if (params) {
        rb.query('selettivaId', params.selettivaId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<SelettivaCountPartecipanteDto>;
        }),
    );
}

apiSelettivaSelettivaCountPartecipantiGet.PATH = '/api/selettiva/selettiva-count-partecipanti';
